import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getList } from 'src/reducers/common/listReducer';
import { REDUCER_NAME, delPayrollRulesGroup } from 'src/reducers/clients/payrollRulesGroups';

import PayrollRulesGroupTableRow from '../components/PayrollRulesGroupTableRow';
import SettingPaymentDate from '../components/SettingPaymentDate';

const PayrollRulesGroupTable = ({ payrollRulesGroups, onDelete }) => {
  const { t } = useTranslation();
  return (
    <table className="m-table-list">
      <thead>
        <tr>
          <th>{t('features.EmployeePays.components.DownloadColumnDetail.salary_rules_group_name')}</th>
          <th>
            {t('features.Employees.components.PayrollRulenInfo.cutoff_date')} /
            {t('features.PayrollRulesGroups.containers.PayrollRulesGroupTable.payment_date')}
            {payrollRulesGroups && payrollRulesGroups.length > 0 && <SettingPaymentDate payrollRulesGroups={payrollRulesGroups} />}
          </th>
          <th>{t('features.PayrollRulesGroups.containers.PayrollRulesGroupTable.Provision_and_deduction_setting')}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {(!payrollRulesGroups || payrollRulesGroups.length === 0) && (
          <tr>
            <td colSpan={4}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
          </tr>
        )}
        {payrollRulesGroups.map(payrollRulesGroup => (
          <PayrollRulesGroupTableRow key={payrollRulesGroup.id} {...payrollRulesGroup} onDelete={onDelete} />
        ))}
      </tbody>
    </table>
  );
};

const mapStateToProps = state => ({
  payrollRulesGroups: getList(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  onDelete: payrollRulesGroupId => {
    dispatch(delPayrollRulesGroup(payrollRulesGroupId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollRulesGroupTable);
